// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__1xAyP","vLegacy":"SelectSecondary_vLegacy__3kcvn","error":"SelectSecondary_error__WDNm2","disabled":"SelectSecondary_disabled__2338i"};